import styled, { css } from 'styled-components';
import React from 'react';
import Button from "../../Button";
import Trash from "../../Icon/Trash";
import Box from "../../Grid/Box";
import Flex from "../../Grid/Flex";
import Dialog from "../../Icon/Dialog";
import colors from "../../../colors";
var RemoveButton = styled(Button).attrs({
  size: 'small',
  icon: true
}).withConfig({
  displayName: "MobileActionButtons__RemoveButton",
  componentId: "sc-72ai8i-0"
})(["", " ", ";"], function (_ref) {
  var theme = _ref.theme;
  return css(["height:", ";width:", ";background-color:", ";border-radius:", "px;"], theme.remove.mobileBtn.height, theme.remove.mobileBtn.width, theme.remove.mobileBtn.bgColor, theme.remove.mobileBtn.borderRadius);
}, function (_ref2) {
  var isKomus = _ref2.isKomus;

  if (isKomus) {
    return css(["background-color:", " !important;"], colors.primaryMain);
  }
});
var CommentButton = styled(Button).attrs({
  size: 'small',
  icon: true
}).withConfig({
  displayName: "MobileActionButtons__CommentButton",
  componentId: "sc-72ai8i-1"
})(["", " ", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return css(["height:", ";width:", ";background-color:", ";border-radius:", "px;"], theme.comment.mobileBtn.height, theme.comment.mobileBtn.width, theme.comment.mobileBtn.bgColor, theme.comment.mobileBtn.borderRadius);
}, function (_ref4) {
  var isKomus = _ref4.isKomus;

  if (isKomus) {
    return css(["background-color:", " !important;"], colors.dark200);
  }
});

var MobileActionButtons = function MobileActionButtons(_ref5) {
  var onRemoveFromCart = _ref5.onRemoveFromCart,
      onCommentMobileBtnSubmit = _ref5.onCommentMobileBtnSubmit,
      isKomus = _ref5.isKomus;
  return React.createElement(React.Fragment, null, onRemoveFromCart && React.createElement(RemoveButton, {
    onClick: onRemoveFromCart,
    isKomus: isKomus
  }, React.createElement(Flex, {
    column: true,
    center: true,
    middle: true
  }, React.createElement(Trash, null), React.createElement(Box, {
    mt: 3
  }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"))), React.createElement(CommentButton, {
    onClick: onCommentMobileBtnSubmit,
    isKomus: isKomus
  }, React.createElement(Flex, {
    column: true,
    center: true,
    middle: true
  }, React.createElement(Dialog, null), React.createElement(Box, {
    mt: 3
  }, "\u041F\u043E\u0436\u0435\u043B\u0430\u043D\u0438\u0435"))));
};

export default MobileActionButtons;